import { useState } from 'react';
import type { CSSProperties, InputHTMLAttributes } from 'react';
import { Eye, EyeOff } from 'lucide-react';

/**
 * 目のアイコンで表示/非表示を切り替えられるパスワード入力。
 * type 以外の input 属性はそのまま透過する。
 * style の margin / width はラッパー側へ移す（アイコンの縦位置を入力欄に合わせるため）。
 */
export default function PasswordInput({ style, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  const [show, setShow] = useState(false);
  const { margin, marginTop, marginRight, marginBottom, marginLeft, width, ...inputStyle } =
    (style ?? {}) as CSSProperties;
  return (
    <div style={{ position: 'relative', margin, marginTop, marginRight, marginBottom, marginLeft, width: width ?? '100%' }}>
      <input
        {...props}
        type={show ? 'text' : 'password'}
        style={{ width: '100%', boxSizing: 'border-box', ...inputStyle, paddingRight: 40 }}
      />
      <button
        type="button" tabIndex={-1} onClick={() => setShow(s => !s)}
        aria-label={show ? 'パスワードを隠す' : 'パスワードを表示'}
        style={{
          position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)',
          background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8',
          padding: 2, display: 'flex', alignItems: 'center',
        }}
      >
        {show ? <EyeOff size={17} /> : <Eye size={17} />}
      </button>
    </div>
  );
}
